import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { exchangeGoogleSession } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || loc.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    exchangeGoogleSession(session_id)
      .then(() => {
        // Clean the hash so it doesn't loop
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("Signed in with Google");
        nav("/dashboard", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed");
        nav("/login", { replace: true });
      });
  }, [exchangeGoogleSession, loc.hash, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="overline mb-3">Signing you in</div>
        <div className="font-serif text-3xl font-semibold tracking-tight">One moment…</div>
      </div>
    </div>
  );
}
